import { getNews } from "../services";
import { useWpFetch } from "../hooks/useWpFetch";
import { Box, Skeleton, Typography } from "@mui/material";
import BlogCard from "../components/BlogCard/BlogCard";

type NewsItem = {
  id: number;
  date: string;
  title: string;
  content: string;
  featured_media: string;
};

const News = () => {
  const { data: news, loading } = useWpFetch(() => getNews(), [], []);

  return (
    <Box className="article-main">
      <Typography
        variant="h4"
        sx={{
          fontFamily: '"Cinzel", serif',
          color: "#4a3728",
          borderBottom: "2px solid #d4b483",
          pb: 1,
          mb: 3,
        }}
      >
        News
      </Typography>

      {loading &&
        [1, 2, 3].map((i) => (
          <Box key={i} sx={{ mb: 3 }}>
            <Skeleton
              variant="rectangular"
              height={180}
              sx={{ borderRadius: 2, mb: 1 }}
            />
            <Skeleton variant="text" width="60%" height={32} />
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width="80%" />
          </Box>
        ))}
      {!loading &&
        news.map((item: NewsItem) => (
          <BlogCard
            key={item.id}
            image={item.featured_media}
            title={item.title}
            date={item.date}
            excerpt={item.content}
            id={item.id}
          />
        ))}
    </Box>
  );
};

export default News;
